import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW1508Component } from './kymw1508.component';
import { GetCwsIconBaseData } from './api-services/get-cws-icon-base-data-service';
import { UpdateCwsIconData } from './api-services/update-cws-icon-data-service';

/**
 * アイコン情報編集画面 モジュール設定クラス
 *
 * @export KYMW1508Module
 * @class KYMW1508Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    WjInputModule,
  ],
  declarations: [
    KYMW1508Component,
  ],
  providers: [
    GetCwsIconBaseData,
    UpdateCwsIconData,
  ],
})
export class KYMW1508Module {
}
